<template>
  <div class="coming-soon" >
    <div style="background-color: #e2e6e6">
      <nav-search-bar
      @search-input="handleSearchInput"
      />
      <nav-category-bar />
      <b-container>
        <div>
          <b-row>
            <b-col>
              <slide-show />
              <!--- Item Cards --->
              <div class="d-none d-md-block" >
              <b-card-group  class="featured-product-deck" deck>
                <products-card
                    v-for="(aCard, i) in productCardsData"
                    :key="`pc-${i}`"
                    :title="aCard.title"
                    :url-display="aCard.urlDisplay"
                    :url-location="aCard.urlLocation"
                    :url-see-more="aCard.urlSeeMore"
                    style="margin-bottom: 25px;"
                />
              </b-card-group>
              </div>
              <div class="d-md-none"  >
                <b-card-group style="margin-top: 25px;" deck>
                  <products-card
                      v-for="(aCard, i) in productCardsData"
                      :key="`pc-${i}`"
                      :title="aCard.title"
                      :url-display="aCard.urlDisplay"
                      :url-location="aCard.urlLocation"
                      :url-see-more="aCard.urlSeeMore"
                      style="margin-bottom: 25px;"
                  />
                </b-card-group>
              </div>
            </b-col>
          </b-row>
        </div>
        <b-row style="background-color: white; margin-top: 150px; padding: 25px; border-radius: 5px">
          <b-col
              sm="4" v-for="(aFave, i) in filteredFaves" :key="`fave-${i}`">
            <product-image
                v-if="false"
                align-v="stretch" style="background-color: blue;height: 400px;"
                :fave-entity="aFave"
            />
            <fave-product-card
                :article="aFave"
            />
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import config from "@/assets/_config.json";
import NavCategoryBar from "./navCategoryBar";
import NavSearchBar from "./navSearchBar";
import SlideShow from "./slideShow";
import ProductsCard from "./productsCard";
import ProductImage from "./productImage";
import RecordViews from "@/mixins/RecordViews";

import FaveProductCard from "./faveProductCard";
import moment from "moment";

export default {
  name: "Home_Site",
  components: {
    NavCategoryBar,
    NavSearchBar,
    ProductsCard,
    ProductImage,
    SlideShow,
    FaveProductCard
  },
  mixins: [RecordViews],
  computed: {
    ...mapGetters({
      allFaves: "admin/faves"
    }),
    filteredFaves() {
      let filtered = [];

      let searchStr = this.searchStr.trim() != "" ? this.searchStr.trim().toLowerCase() : null;

      filtered = this.allFaves.filter(anItem => {
        return  anItem.status =="approved";
      });
      return filtered;
    }
  },
  created() {
    this.getFaves();
  },
  methods: {
    handleSearchInput(searchInput){
      this.searchStr= searchInput;
    },
    getFaves() {
      this.$store.dispatch("admin/getFaves").then(res => {
        console.log(res);
      });
    },
    formatDate(date) {
      return date
          ? moment(date.toDate()).format("MMMM DD, YYYY h:MM a")
          : "N/A";
    }
  },
  mounted() {},
  data() {
    return {
      id: "success-modal",
      searchStr:"",
      config,
      loading: false,
      productCardsData:[
        {
          title: "Pick up where you left off",
          urlDisplay:"https://firebasestorage.googleapis.com/v0/b/derriana.appspot.com/o/derriana_faves_imgs%2F81a6hXEaJVL._AC_SX679_.jpg_L5s5tsOH2H34rTI_1704586430255?alt=media&token=e13b1ffc-a94a-4689-a385-6a33a941f4d6",
          urlSeeMore:"https://www.amazon.com/s?k=best+squishmallows+for+girls&i=instant-video&crid=2B82WFAE1NH21&sprefix=squishmallows+for+girls%2Cinstant-video%2C112&ref=nb_sb_ss_ts-doa-p_4_23",
          urlLocation:"https://www.amazon.com/s?k=best+squishmallows+for+girls&i=instant-video&crid=2B82WFAE1NH21&sprefix=squishmallows+for+girls%2Cinstant-video%2C112&ref=nb_sb_ss_ts-doa-p_4_23"
        },
        {
          title: "Beauty and Body Care",
          urlDisplay:"https://firebasestorage.googleapis.com/v0/b/derriana.appspot.com/o/derriana_faves_imgs%2Fimages.jpg_hpRicebSIlbAVWD_1704586888837?alt=media&token=b19b7709-79c9-40ab-8207-e6731b174ac8",
          urlSeeMore:"https://www.amazon.com/s?k=sol+de+janeiro&crid=P02L6P8YFPCO&sprefix=sol+de+janeiro%2Caps%2C100&ref=nb_sb_noss_2",
          urlLocation:"https://www.amazon.com/s?k=sol+de+janeiro&crid=P02L6P8YFPCO&sprefix=sol+de+janeiro%2Caps%2C100&ref=nb_sb_noss_2"
        },
        {
          title: "Shop Gift Cards",
          urlDisplay:"https://firebasestorage.googleapis.com/v0/b/derriana.appspot.com/o/derriana_faves_imgs%2Fdownload.jpg_DcYG9hFoUfWtkCY_1704586014341?alt=media&token=9cfbb450-982d-4dec-82ac-2592e531b28a",
          urlSeeMore:"https://www.target.com/c/target-giftcards-gift-cards/-/N-5xsxt",
          urlLocation:"https://www.target.com/c/target-giftcards-gift-cards/-/N-5xsxt"
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.coming-soon {
  padding-top: 100px;
  background: #FE828C;
}

.featured-product-deck {
  position: absolute;
  left: 5%;
  top: 50%;
  color: #272f75;
  font-weight: bold;
  cursor: pointer;
  font-size: 12px;
}

</style>
